import { getApiClient } from './client';
import type { Folder } from '@/types/domain';

export interface MoveFolderArgs {
  folderId: string;
  newParentId: string | null;
  newContainerId?: string;
}

export async function moveFolderApi(args: MoveFolderArgs): Promise<Folder> {
  return getApiClient().post('outlook-move-folder', { json: args }).json<Folder>();
}

export interface CopyFolderArgs {
  folderId: string;
  /** `null` = racine du conteneur cible. */
  targetParentId: string | null;
  /** Omis = même conteneur que la source. */
  targetContainerId?: string;
}

export interface CopyFolderResult {
  status: 'created';
  folderId: string;
  /**
   * Nom réellement retenu : le serveur ajoute « (copie) » si un dossier de même
   * nom existe déjà à la destination — cas le plus courant, puisqu'on copie
   * souvent un dossier à côté de lui-même.
   */
  name: string;
  folderCount: number;
  mailCount: number;
}

/**
 * Copie PROFONDE d'un dossier : ses sous-dossiers ET ses mails (objets S3
 * dupliqués côté serveur).
 *
 * Le serveur refuse au-delà de 100 sous-dossiers ou 300 mails — au-delà, la copie
 * ne tiendrait pas dans le temps d'exécution d'une fonction edge (60 s) et
 * s'interromprait au milieu. Le message d'erreur est affichable tel quel.
 *
 * Timeout client généreux pour la même raison que `fileMail` : les 30 s par
 * défaut de ky seraient dépassées par une copie de plusieurs centaines de mails
 * alors que le serveur, lui, va jusqu'au bout.
 */
export async function copyFolderApi(args: CopyFolderArgs): Promise<CopyFolderResult> {
  return getApiClient()
    .post('outlook-copy-folder', { json: args, timeout: 120_000 })
    .json<CopyFolderResult>();
}
